// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
      	activeLoadPreviousPage: true
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    // Card Template
    'productCardItemHtml': '<div id="gridparent" class="grid__item ' + bcSfFilterConfig.custom.collection_products_per_row + ' quarter-width medium--one-half small--one-half ee product-second-square-{{index}}">' +
                               '<div id="dummy"></div>' +
                                '<div id="element" class="collection-product {{itemSoldOutClass}}">' +
                                    '{{itemLabels}}' +
                                    '<div class="{{itemCycleClass}} card-shadow">' +
                                        '<a href="{{itemUrl}}" class="grid__image {{itemSoldOutImageClass}}">' +
                                            '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                        '</a>' +
                                        '<div class="product-overlay">' +
                                            '<a href="{{itemUrl}}" class="product-grid-card-wrapper"> </a>' +
                                            '<a href="{{itemUrl}}" class="product-grid-card-link">' +
                                                '<p class="h2 product-title">{{itemMinTitle}}</p>' +
                                                '{{itemPrice}}' +
                                            '</a>' +
                                        '</div>' +
                                    '</div>' + 
                                    '<div class="large--hide medium-down--show card-shadow mobile-square-title {{itemCycleMobileClass}}">' +
                                        '<a href="{{itemTitle}}" class="product-grid-card-link">' +
                                            '<div class="mobile-price-container">' +
                                                '<p class="h2 product-title">' +
                                                    '<a href="{{itemUrl}}">{{itemMinTitle2}}</a>' +
                                                '</p>' +
                                                '{{itemPriceMobile}}' +
                                            '</div>' +
                                        '</a>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                            '{{itemAdditional}}',
  
    // Grid Template
    'productGridItemHtml': '<div class="grid__item ' + bcSfFilterConfig.custom.grid_item_width + ' text-center grid-product-container">' +
                                '<div class="ptest">' +
                                    //'<div id="relproduct-dummy"></div>' +
                                    '<a href="{{itemUrl}}">' +
                                        '<div {{itemSoldoutClass}} class="reveal">' +
                                            '<img class="itest" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
  											'<img class="hidden" src="{{itemThumbUrl2}}" alt="{{itemTitle}}">' +
                                        '</div>' +
                                    '</a>' +
                                '</div>' +
                                '<p>' +
                                    '<a href="{{itemUrl}}">' +
                                        '{{itemLabels}}' +
                                        '{{itemMinTitle}}' +
                                    '</a>' +
                                '</p>' +
                                '<div class="product-price-grid dfdff">{{itemPrice}}</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title="">←</a></span>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title="">→</a></span>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="deco">{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    if (bcSfFilterConfig.custom.collection_style == 'card') {
        var itemHtml = bcSfFilterTemplate.productCardItemHtml;
    } else {
        var itemHtml = bcSfFilterTemplate.productGridItemHtml;
    }

    // Add custom class
    var itemSoldOutClass = soldOut ? 'collection-product-sold-out' : '';
    var itemSoldOutImageClass = soldOut ? 'collection-product-unavailable' : '';
    var itemCycleClass = (index == 1 || index % 2 == 1) ? 'collection-box-1' : 'collection-box-2';
    var itemCycleMobileClass = (index == 1 || index % 2 == 1) ? 'mobile-collection-margin-1' : 'mobile-collection-margin-2';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);
    itemHtml = itemHtml.replace(/{{itemSoldOutImageClass}}/g, itemSoldOutImageClass);
    itemHtml = itemHtml.replace(/{{itemCycleClass}}/g, itemCycleClass);
    itemHtml = itemHtml.replace(/{{itemCycleMobileClass}}/g, itemCycleMobileClass);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '400x1000') : bcSfFilterConfig.general.no_image_url;
    var itemThumbUrl2 = this.optimizeImage(images[images.length-1]['src'], '400x1000');
  
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
  itemHtml = itemHtml.replace(/{{itemThumbUrl2}}/g, itemThumbUrl2);

    // Add Price
    var exclPrice = data.price_min-(data.price_min/6);
    var itemOffPrice = '<p class="sprice">'+ this.formatMoney(exclPrice - exclPrice*15/100 )+'<span class="offvalue">(15% OFF)</span></p>';
    var exclVat = '<span class="exclVat">(excl. VAT)</span>';
    var isuserLoggedIn = bcSfFilterConfig.custom.is_user_logged_in;
    var customerTag = bcSfFilterConfig.custom.customer_tag;
    var itemPriceHtml = '';
    if (bcSfFilterConfig.custom.collection_style == 'card') {
        if (priceVaries) {
          
            
            if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
            itemPriceHtml += '<p class="h2 product-price">' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(exclPrice));
            itemPriceHtml += exclVat;
          }else{
          itemPriceHtml += '<p class="h2 product-price">' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min));
        }
            itemPriceHtml += '</p>';
            if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
            itemPriceHtml += itemOffPrice;
        }
        } else {
            
            if (isuserLoggedIn == 'True'  && customerTag.includes('TRADE15')){
            itemPriceHtml += '<p class="h2 product-price">' + this.formatMoney(exclPrice);
            itemPriceHtml += exclVat;
        }else{
        itemPriceHtml += '<p class="h2 product-price">' + this.formatMoney(data.price_min);
      }
            itemPriceHtml += '</p>';
            if (isuserLoggedIn == 'True'  && customerTag.includes('TRADE15')){
            itemPriceHtml += itemOffPrice;
        }
        }
    } else {
        if (onSale) {
            if (priceVaries) {
                
                if (isuserLoggedIn == 'True'  && customerTag.includes('TRADE15')){
                itemPriceHtml += '<p class="product-price">' + bcSfFilterConfig.label.sale_from_price.replace(/{{ price }}/g, this.formatMoney(exclPrice)) ;
            itemPriceHtml += exclVat;
        }else{
        itemPriceHtml += '<p class="product-price">' + bcSfFilterConfig.label.sale_from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min)) ;
    }
                itemPriceHtml += '</p>';
                if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
            itemPriceHtml += itemOffPrice;
        }
            } else {
                
                if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
                itemPriceHtml += '<p class="product-price">' + this.formatMoney(exclPrice) + ' <span class="grid_compare_price">' + this.formatMoney(data.compare_at_price_min-data.compare_at_price_min/6) + '</span>';
            itemPriceHtml += exclVat;
        }else{
        itemPriceHtml += '<p class="product-price">' + this.formatMoney(data.price_min) + ' <span class="grid_compare_price">' + this.formatMoney(data.compare_at_price_min) + '</span>';
    }
              itemPriceHtml += '</p>';
              if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
            itemPriceHtml += itemOffPrice;
        }
            }
        } else {
            if (priceVaries) {
                
                if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
                itemPriceHtml += '<p class="product-price">' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(exclPrice)) ;
            itemPriceHtml += exclVat;
        }else{
        itemPriceHtml += '<p class="product-price">' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min)) ;
    }
                itemPriceHtml += '</p>';
                if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
            itemPriceHtml += itemOffPrice;
        }
            } else {
                
                if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
                itemPriceHtml += '<p class="product-price">' + this.formatMoney(exclPrice);
            itemPriceHtml += exclVat;
        }else{
        itemPriceHtml += '<p class="product-price">' + this.formatMoney(data.price_min);
    }
                itemPriceHtml += '</p>';
                if (isuserLoggedIn == 'True' && customerTag.includes('TRADE15')){
            itemPriceHtml += itemOffPrice;
        }
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Price Mobile
    var itemPriceMobileHtml = '';
    if (onSale) {
        if (priceVaries) {
            itemPriceMobileHtml += '<p class="h3 product-price product-on-sale">' + bcSfFilterConfig.label.sale_from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min) )+ '</p>';
        } else {
            itemPriceMobileHtml += '<p class="h3 product-price">' + this.formatMoney(data.price_min) + '</p>';
        }
    } else {
        if (priceVaries) {
            itemPriceMobileHtml += '<p class="h3 product-price">';
            if (soldOut) {
                itemPriceMobileHtml += '<s>' + bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min)) + '</s>';
            } else {
                itemPriceMobileHtml += bcSfFilterConfig.label.from_price.replace(/{{ price }}/g, this.formatMoney(data.price_min));
            }
        } else {
            itemPriceMobileHtml += '<p class="h3 product-price">';
            if (soldOut) {
                itemPriceMobileHtml += '<s>' + this.formatMoney(data.price_min) + '</s>';
            } else {
                itemPriceMobileHtml += this.formatMoney(data.price_min);
            }
        }
        itemPriceMobileHtml += '</p>';
    }
    itemHtml = itemHtml.replace(/{{itemPriceMobile}}/g, itemPriceMobileHtml);

    // Add Labels
    var itemLabelsHtml = '';
    if (soldOut) {
        itemLabelsHtml += '<div class="sold-out">';
        itemLabelsHtml += '<span class="icon icon-soldout" aria-hidden="true"></span>';
        itemLabelsHtml += '<span class="fallback-text"></span>';
        itemLabelsHtml += '<div class="Sold Out Badge collection-product-soldout-badge"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><g><title>Layer 1</title><ellipse stroke="#000" ry="30" rx="30" cy="30" cx="30" stroke-width="0" fill="{{settings.sold_badge_color}}"></ellipse><text font-weight="bold" stroke="#000" xml:space="preserve" text-anchor="middle" font-family="Helvetica, Arial, sans-serif" font-size="10px"  y="33" x="29" stroke-opacity="null" stroke-width="0" fill="#ffffff">SOLD-OUT</text></g></svg></div>';
        itemLabelsHtml += '</div>';
    } else {
        if (onSale) {
            itemLabelsHtml += '<div>';
            itemLabelsHtml += '<span class="icon icon-sale" aria-hidden="true"></span>';
            itemLabelsHtml += '<span class="fallback-text"></span>';
            itemLabelsHtml += '<div class="sale-badge collection-product-sale-badge"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><g><ellipse ry="30" rx="30"  cy="30" cx="30" stroke-width="0" stroke="black" fill="' + bcSfFilterConfig.custom.sale_badge_color + '"></ellipse><text font-weight="bold" stroke="#000" xml:space="preserve" text-anchor="middle" font-family="Helvetica, Arial, sans-serif" font-size="12px"  y="33" x="29" stroke-opacity="null" stroke-width="0" fill="#ffffff">SALE</text></g></svg></div>';
            itemLabelsHtml += '</div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Min Title
    var itemMinTitle = this.truncateByWord(data.title, 10);
    var itemMinTitle2 = this.truncateByChar(data.title, 25);
    itemHtml = itemHtml.replace(/{{itemMinTitle}}/g, itemMinTitle);
    itemHtml = itemHtml.replace(/{{itemMinTitle2}}/g, itemMinTitle2);

    // Additional item
    var itemAdditionalHtml = '';
    if (index == 2 && bcSfFilterConfig.custom.collection_ad_text_richtext != '') {
        itemAdditionalHtml +=   '<div id="gridparentad" class="grid__item ' + bcSfFilterConfig.custom.collection_products_per_row + '  collection-ad-mobile margin-B-M ' + bcSfFilterConfig.custom.collection_column_width + ' quarter-width product-square-grid-ad medium--one-half ff small--one-whole product-grid-square">' +
                                    '<div id="dummy"></div>' +
                                    '<div class="collection-page-ad card-shadow collection-product collection-box-1" id="element">' +
                                        '<div class="collection-ad-text rte">' +
                                            '<h1>' + this.truncateByChar(bcSfFilterConfig.custom.collection_ad_text_richtext, 140) + '</h1>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemAdditional}}/g, itemAdditionalHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{index}}/g, index);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.pagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.pagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  // Avoid load products twice
  var self = this;  
  if (!self.getSettingValue('general.showPlaceholderProductList')) {
     jQ(self.selector.products).removeClass('bc-sf-product-loading');          
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

BCSfFilter.prototype.buildPaginationEvent = function(data) {
  switch (this.getSettingValue('general.paginationType')) {
    case 'default':
      this.buildDefaultPaginationEvent(data);
      break;
    case 'load_more':
      this.buildLoadMoreEvent(data);
      this.buildLoadPreviousPageEvent(data);
      break;
    default:
      this.buildInfiniteLoadingEvent(data);
      this.buildLoadPreviousPageEvent(data);
      break;
  }
};

BCSfFilter.prototype.isLoadPreviousPagePaginationType = function() {
  var self = this;
  return (self.isInfiniteLoadingPaginationType() || self.isLoadMorePaginationType()) && self.isAdvancedPaginationType() && self.getSettingValue('general.activeLoadPreviousPage') &&
  jQ(self.getSelector('btnLoadPreviousPageWrapperSelector')).length > 0;
};

// Build Infinite Loading event
BCSfFilter.prototype.buildInfiniteLoadingEvent = function(data) {
  var self = this;
  // Get total products
  var totalProduct = parseInt(data.total_product);
  /* Get limit per page */
  var limitPerPage = parseInt(self.getSettingValue('general.limit'));
  var currentPage = parseInt(self.queryParams.page);
  // Previous page data
  var bcSfFilterCurrentNextPage;
  if (self.isLoadPreviousPagePaginationType()) {
    bcSfFilterCurrentNextPage = parseInt(sessionStorage.getItem(self.getSettingValue('general.sessionStorageCurrentNextPage')));
  } else {
    bcSfFilterCurrentNextPage = currentPage;
  }
  
  
  /* Check if total products is greater than limit per page * curent page, do the infinite loading function, else do nothing */
  if (totalProduct > (limitPerPage * bcSfFilterCurrentNextPage)) {

    // Using scrolling to prevent callling onscroll twice
    var scrolling = 0;

    // onscroll event
    // When windown reaches the bottom of product list
    var scrollToBottom = false;

    // Pagination selector
    var paginationSelector = jQ(self.getSelector('bottomPagination'));

    // Check if pagination exists, do the infinite function
    if (paginationSelector.length > 0) {
      // When scroll down, do the infinite function
      jQ(window).scroll(function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Ignore load more if the product list is loading
        if (jQ(self.selector.products).hasClass('bc-sf-product-loading')) return false;        
        

        // get height of scroll bar
        var scrollbarHeight = jQ(window).height() * (jQ(window).height() / jQ(document).outerHeight());

        // get position of the pagination bottom
        var maxPos = parseInt(paginationSelector.offset().top);
        var maxScroll = parseInt(jQ(window).scrollTop()) + scrollbarHeight + self.getSettingValue('general.positionShowInfiniteLoading');
        if ((jQ(window).scrollTop() + jQ(window).height() + scrollbarHeight) >= jQ(document).outerHeight() - 100) {
          scrollToBottom = true;
        }

        // Begin loading more products
        if (scrolling == 0 && data.products.length > 0) {
          if (maxScroll >= maxPos || (maxScroll < maxPos && scrollToBottom)) {
            // Show Loading
            self.showLoadMoreLoading();

            // Prevent scrolling twice
            scrolling = 1;
            
            // Previous page data
            if (self.isLoadPreviousPagePaginationType()) {
              bcSfFilterCurrentNextPage = parseInt(sessionStorage.getItem(self.getSettingValue('general.sessionStorageCurrentNextPage')));
            } else {
              bcSfFilterCurrentNextPage = currentPage;
            }

            // Next page
            bcSfFilterCurrentNextPage++;
            

            // Send request if current page is smaller or equal to total number of pages
            var totalPage = Math.ceil(data.total_product / self.getSettingValue('general.limit'));
            // console.log(currentPage, totalPage);
            if (bcSfFilterCurrentNextPage <= totalPage) {
              self.internalClick = true;
              self.queryParams.limit = self.getSettingValue('general.limit');
              self.queryParams.page = bcSfFilterCurrentNextPage;
              
              // Avoid load twice
              if (!self.getSettingValue('general.showPlaceholderProductList')) {
                jQ(self.selector.products).addClass('bc-sf-product-loading');          
              }
              
              // Append "page" param to url
              // Used to Scroll to the previous position after returning from Product page
              if (self.getSettingValue('general.paginationTypeAdvanced')) {
                var newUrl = self.buildToolbarLink('page', getCurrPage() , bcSfFilterCurrentNextPage);
                // If the previous page feature is activated
                if (self.isLoadPreviousPagePaginationType()) {
                  // Save the previous page data                  
                  sessionStorage.setItem(self.getSettingValue('general.sessionStorageCurrentNextPage'), bcSfFilterCurrentNextPage);
                  sessionStorage.setItem(self.getSettingValue('general.sessionStoragePreviousPageEvent'), 0);
                }
                self.onChangeData(newUrl, 'page');
              } else {
                self.getFilterData('page');
              }
            }
          }
        }
      });
    }
  }
};

/* Parse URL parameters */
function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

/* Get the current page from address */
function getCurrPage() {
  var url = parse_query_string(window.location.search.substring(1));
  return url.page;
}

BCSfFilter.prototype.buildAll = function(data, isBuildFilterTree, eventType) {
  var self = this;
    // Prepare data
    var paginationSelector = this.selector.pagination;
    var totalProduct = data.total_product;

    if (isBuildFilterTree === true && data.hasOwnProperty('filter')) {
        // Build Filter Tree
        this.buildFilterTree(data.filter.options);
        // Build Filter Selections
        if (this.getSettingValue('general.showRefineBy')) {
            this.buildFilterSelection(data);
        }
        // Customize Filter tree on mobile
        this.buildFilterTreeMobile();
        // Build Filter Tree Button for Mobile
        this.buildFilterTreeMobileButton(data);
        // Build events: clear filter option, clear all filter options and toggle on title
        this.buildAdditionalFilterEvent();
    }
    if (totalProduct > 0) {
        // Build Product List
        this.buildProductList(data.products, eventType);
        // Build Pagination
        var paginationType = this.getSettingValue('general.paginationType');
        if (paginationType == 'default') {
            this.buildPagination(totalProduct);
        } else {
            jQ(paginationSelector).empty();
            if (self.isLoadMorePaginationType()) {
              // Build load more button
              this.buildLoadMoreButton(totalProduct);
              // Build previous button
              this.buildLoadPreviousButton(totalProduct, eventType);
            } else if (self.isInfiniteLoadingPaginationType()) {              
              // Build previous button
              this.buildLoadPreviousButton(totalProduct, eventType);
            }
        }
        // Build Toolbar
        this.buildToolbar();
        // Build Toolbar Event (Pagination, Sorting,...)
        this.buildToolbarEvent(data);
        // Hide Error Notification after build succesfully
        jQ(this.selector.filterWrapper).show();
        var topNotificationSelector = this.selector.topNotification;
        if (jQ(topNotificationSelector).length > 0) jQ(topNotificationSelector).empty();
    }

    // Show Products & Pagination after building (also used for Fallback)
    jQ(this.selector.products).removeAttr('data-bc-sort');
    jQ(paginationSelector).show();

    // Build Additional Elements
    this.buildAdditionalElements(data, eventType);

    // Build Scroll to Top
    this.buildScrollToTop();

    // Scroll to previous position when going back from product page
    this.scrollBackPositionHistoryBack();

    // Build Page information
    if (eventType == 'collection') this.buildPageInfo(data);

    // Build Search
    if (this.isSearchPage()) {
        this.buildSEOTitle(data);
        this.buildSearchResultHeader(data);
        this.buildSearchResultNumber(data);
    }

    // Add Meta tag to exclude pages with filter params from Goolge crawl
    this.buildRobotsMetaTag(data);

    this.selectFilter = false;
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
